module.exports = __webpack_public_path__ + "img/package-receipt.d0b9ea55.svg";